import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Paper,
  Switch,
  FormControlLabel,
  TextField,
  List,
  ListItem,
  ListItemText,
  Divider
} from '@mui/material';
import { Timeline, TimelineItem, TimelineSeparator, TimelineConnector, TimelineContent, TimelineDot } from '@mui/lab';
import ApiService from '../services/ApiService';

const FulfillmentUpdatesDialog = ({ open, onClose, requestId, updates = [], onUpdateAdded }) => {
  const [showVisualization, setShowVisualization] = useState(false);
  const [newComment, setNewComment] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  // Format date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString();
  };
  
  const handleAddUpdate = async () => {
    if (!newComment.trim()) return;
    
    setIsSubmitting(true);
    try {
      const result = await ApiService.addFulfillmentUpdate(requestId, newComment);
      setNewComment('');
      if (onUpdateAdded) onUpdateAdded(result.updates);
    } catch (error) {
      console.error('Failed to add update:', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Fulfillment Updates</Typography>
          <FormControlLabel
            control={
              <Switch
                checked={showVisualization}
                onChange={() => setShowVisualization(!showVisualization)}
                color="primary"
              />
            }
            label="Timeline View"
          />
        </Box>
      </DialogTitle>
      <DialogContent dividers>
        {updates.length === 0 ? (
          <Typography variant="body1" align="center" color="textSecondary" sx={{ py: 4 }}>
            No updates available for this request.
          </Typography>
        ) : showVisualization ? (
          // Timeline visualization
          <Timeline position="alternate">
            {updates.map((update, index) => (
              <TimelineItem key={index}>
                <TimelineSeparator>
                  <TimelineDot color="primary" />
                  {index < updates.length - 1 && <TimelineConnector />}
                </TimelineSeparator>
                <TimelineContent>
                  <Paper elevation={3} sx={{ p: 2, bgcolor: '#f5f5f5' }}>
                    <Typography variant="subtitle2" color="primary">
                      {formatDate(update.timestamp)}
                    </Typography>
                    <Typography>{update.comment}</Typography>
                  </Paper>
                </TimelineContent>
              </TimelineItem>
            ))}
          </Timeline>
        ) : (
          // List view
          <List>
            {updates.map((update, index) => (
              <React.Fragment key={index}>
                <ListItem alignItems="flex-start">
                  <ListItemText
                    primary={formatDate(update.timestamp)}
                    secondary={update.comment}
                  />
                </ListItem>
                {index < updates.length - 1 && <Divider />}
              </React.Fragment>
            ))}
          </List>
        )}
        
        {/* Add new comment section - COMMENTED OUT AS REQUESTED
        <Box mt={3} display="flex" flexDirection="column">
          <Typography variant="subtitle1" gutterBottom>
            Add New Update
          </Typography>
          <Box display="flex" gap={2}>
            <TextField
              fullWidth
              multiline
              rows={2}
              variant="outlined"
              placeholder="Enter update comment"
              value={newComment}
              onChange={(e) => setNewComment(e.target.value)}
            />
            <Button
              variant="contained"
              color="primary"
              onClick={handleAddUpdate}
              disabled={!newComment.trim() || isSubmitting}
              sx={{ alignSelf: 'flex-end' }}
            >
              Add
            </Button>
          </Box>
        </Box>
        */}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FulfillmentUpdatesDialog;